import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Button } from "antd";
import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import TitleComponent from "../Title/Title";
import FormTemplate from "../../FormTemplates";
import StyledCard from "../StyledCard/StyledCard";

const rowStyle = {
  display: 'flex',
  borderBottom: '1px solid rgba(180,180,180,0.34)',
};

const cellStyle = {
  flex: 1,
  padding: '10px',
  borderRight: '1px solid rgba(180,180,180,0.34)',
  background: 'white',
  fontSize: 14,
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  background: '#FCF8F8', // match Figma value cell background
};

const { background, ...cellStyleWithoutBg } = cellStyle;

const lastCellStyle = {
  ...cellStyleWithoutBg,
  borderRight: 'none',
  justifyContent: 'flex-start',
  borderRadius: 0,
};


const FormsList = ({ data }) => {
  console.log("388888",data)
  data = { ...data, ...data?.W4SectionDetails, ...data['jobDetails&I9Section1'], ...data?.bankDetails, ...data?.signatureDetails, ...data['jobDetails&I9Section2'] }

  const { t } = useTranslation();
  const [openTemplate, setOpenTemplate] = useState(false);
  const [templateName, setTemplateName] = useState("");

  const location = useLocation();
  const isPayrollAdmin = location?.pathname?.includes('payroll')

  const formsForSupervisor = [
    { name: t("onboarding.forms.rights"), id: 'EmployeeRights' },
    { name: t("onboarding.forms.i9"), id: 'I9-Form' },
  ]

  const formsForPayrollAdmin = [
    { name: t("onboarding.forms.w4"), id: 'W4-Form' },
    { name: t("onboarding.forms.rights"), id: 'EmployeeRights' },
    { name: t("onboarding.forms.i9"), id: 'I9-Form' },
    { name: t("onboarding.forms.payroll"), id: 'PayrollDirectDeposit' },
  ];

  const defaultForms = isPayrollAdmin ? formsForPayrollAdmin : formsForSupervisor;

  const previewTemplate = async (id) => {
    setTemplateName(id);
    setOpenTemplate(true);
  }

  return (
    <>
      <div>
        <TitleComponent title={t('onboarding.forms.importantForms')} />
        <StyledCard>
          {defaultForms.map((form, index) => (<div style={rowStyle}>
            <div style={cellStyle}>{form.name}</div>
            <div style={lastCellStyle}>
              <Button
                type="text"
                icon={<EyeOutlined style={{ color: '#1677ff' }} />}
                style={{ padding: 5 }}
                size="small"
                onClick={() => previewTemplate(form.id)}
                aria-label={t("onboarding.forms.view")}
              >
              <span style={{ color: '#1677ff', fontSize:'12px', marginLeft:'-5px' }}>{t("onboarding.forms.view").toLowerCase()} </span>
              </Button>
            </div>
          </div>))}
        </StyledCard>
      </div>
      <FormTemplate
        openTemplate={openTemplate}
        setOpenTemplate={setOpenTemplate}
        templateName={templateName}
        data={data}
      />
    </>
    )
}


export default FormsList;